module.exports = __webpack_public_path__ + "static/media/icon-nav-wallet.f94c3639.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-nav-wallet.svg
// module id = 1218
// module chunks = 19